import { Component, h, Prop, Element, State } from "@stencil/core"

/**
 * The component containg the input for OTP. Supports autofill from the SMS.
 */
@Component({
  tag: "otp-input",
  styleUrl: "OtpInput.scss",
})
export class OtpInput {
  /**
   * Error message displayed below the OTP input.
   */
  @Prop() errorMessage: string

  /**
   * Callback called every time user inputs the OTP number
   *
   * @param value Value with the OTP value.
   */
  @Prop() otpOnInput: (value: string | null) => void

  /**
   * Callback called after user click enter.
   */
  @Prop() otpOnEnterClick: (() => void) | undefined

  @Element() htmlElement: HTMLElement
  private inputArray: HTMLInputElement[] = []

  private otpLength: number = 6
  @State() otpInputValue: string[] = []
  private otpInputRegex = new RegExp(/^[0-9]{1,6}$/)

  componentDidLoad() {
    const shadowElement = this.htmlElement
    this.inputArray = Array.from(shadowElement.querySelectorAll("#otpInput > .otpInput"))
    this.focusOnLastEmpty()
  }

  handleOnInput = (event: Event, index: number) => {
    const inputElement = event.target as HTMLInputElement
    let inputValue = inputElement.value
    const isInputElementValueDigit = this.otpInputRegex.test(inputValue)

    if (!isInputElementValueDigit) {
      event.preventDefault()
    }

    inputValue = isInputElementValueDigit ? inputValue.slice(0, this.otpLength) : ""

    const inputValueLength = inputValue.length

    if (inputValueLength === 1) {
      this.otpInputValue[index] = inputValue
      const newOtpValue = this.otpInputValue.join("")

      this.otpOnInput(newOtpValue)
      this.focusOnNextInput(inputElement)
    } else if (inputValueLength === this.otpLength) {
      inputValue.split("").forEach((splitValue: string, splitIndex: number) => {
        this.otpInputValue[splitIndex] = splitValue
        this.inputArray[splitIndex].value = splitValue
        this.inputArray[splitIndex].focus()
      })

      this.otpOnInput(inputValue)
    } else {
      this.otpInputValue[index] = inputValue.slice(0, 1)
      this.inputArray[index].value = inputValue.slice(0, 1)
      this.inputArray[index].focus()
      event.preventDefault()
    }
  }

  handleOnKeyDown = (event: Event) => {
    const inputElement = event.target as HTMLInputElement
    const inputKeyboardEvent = event as KeyboardEvent

    if (inputKeyboardEvent.key === "Enter") {
      event.preventDefault()
      typeof this.otpOnEnterClick === "function" && this.otpOnEnterClick()
    }

    if (inputKeyboardEvent.key !== "Backspace" || inputElement.value !== "") return

    this.focusOnPrevInput(inputElement)
  }

  focusOnNextInput = (input: HTMLElement) => {
    const nextElementSibling = input.nextElementSibling as HTMLInputElement | null
    if (nextElementSibling) {
      nextElementSibling.focus()
      nextElementSibling.setSelectionRange(0, 1)
    }
  }

  focusOnPrevInput = (input: HTMLElement) => {
    const previousElementSibling = input.previousElementSibling as HTMLInputElement | null
    if (previousElementSibling) {
      previousElementSibling.focus()
      previousElementSibling.setSelectionRange(0, 1)
    }
  }

  focusOnLastEmpty = () => {
    console.group("focusOnLastEmpty")
    console.log("otpInputValue", this.otpInputValue)

    const getCountOfNonEmptyInputs = this.otpInputValue.filter(input => input !== "").length
    const getFirstEmptyInputIndex = this.otpInputValue.indexOf("") || 0
    let indexOfFocusedInput = 0

    console.log("getCountOfNonEmptyInputs", getCountOfNonEmptyInputs)
    console.log("getFirstEmptyInputIndex", getFirstEmptyInputIndex)

    if (getCountOfNonEmptyInputs < this.otpLength) {
      indexOfFocusedInput = getFirstEmptyInputIndex
    } else {
      indexOfFocusedInput = this.otpLength - 1
    }

    console.log("indexOfFocusedInput", indexOfFocusedInput)
    console.groupEnd()

    this.inputArray[indexOfFocusedInput].focus()
    this.inputArray[indexOfFocusedInput].setSelectionRange(0, 1)
  }

  private getOtpArray(): string[] {
    if (this.otpInputValue.length !== this.otpLength) {
      const otpArray = new Array(this.otpLength).fill("")
      this.otpInputValue = otpArray
      return otpArray
    } else {
      return this.otpInputValue
    }
  }

  render() {
    return (
      <div class="otpParentDiv">
        <div class={"otpInputDiv" + (this.errorMessage ? " errorOutline" : "")}>
          <div id="otpInput">
            {this.getOtpArray().map((value, index) => (
              <input
                key={index}
                id={"otpInputElement" + index}
                class="otpInput"
                type={"text"}
                inputMode={"numeric"}
                autoComplete={"one-time-code"}
                pattern="\d{1}"
                maxLength={this.otpLength}
                value={value}
                onInput={event => this.handleOnInput(event, index)}
                onKeyDown={this.handleOnKeyDown}
                onClick={this.focusOnLastEmpty}
                required
              />
            ))}
          </div>
        </div>
        {this.errorMessage && <label class="otpMinorError">{this.errorMessage}</label>}
      </div>
    )
  }
}
